import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './CreateClass.css';
import { routeCreateEvaluation, routeGetEvaluations, getClases, routeUpdateEvaluation } from "./constants";
import 'react-dropdown/style.css';

export const CreateEvaluation = () => {
    const [matriculaClase, setMatriculaClase] = useState('');
    const [idClase, setIdClase] = useState('');
    const [evaluacionDiagnostica, setEvaluacionDiagnostica] = useState('');
    const [evaluacionFinal, setEvaluacionFinal] = useState('');
    const [satisfaccion, setSatisfaccion] = useState('');
    const [error, setError] = useState('');
    const [optionsMatricula, setOptionsMatricula] = useState([]);
    const [matriculas, setMatriculas] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        callMatriculas();
    }, []);

    const callMatriculas = async () => {
        try {
            const response = await axios.get(getClases);
            const nuevasOpciones = response.data.map(clase => `${clase.matricula_clase} - ${clase.nombre_clase}`);
            setOptionsMatricula(nuevasOpciones);
            setMatriculas(response.data);
        } catch (error) {
            console.error('Error al obtener clases', error);
        }
    };

    const fetchEvaluacionData = async (idClase) => {
        try {
            const response = await axios.get(routeGetEvaluations, {
                params: { id_evaluaciones: idClase }
            });
            if (response.data) {
                setEvaluacionDiagnostica(response.data.evaluacion_diagnostica || '');
                setEvaluacionFinal(response.data.evaluacion_final || '');
                setSatisfaccion(response.data.satisfaccion || '');
            }
        } catch (error) {
            console.error('Error al obtener la evaluación', error);
        }
    };

    const handleSelection = (event) => {
        setMatriculaClase(event.target.value);
        const claseSeleccionada = matriculas.find(m => `${m.matricula_clase} - ${m.nombre_clase}` === event.target.value);
        if (claseSeleccionada) {
            setIdClase(claseSeleccionada.id_clase);
            fetchEvaluacionData(claseSeleccionada.id_clase); // Obtener datos al cambiar
        }
    };
const handleSubmitEvaluation = async (e) => {
    e.preventDefault();
    setError('');

    try {
        // 1️⃣ Verificar si existe la evaluación
        const check = await axios.get(routeGetEvaluations, {
            params: { id_evaluaciones: idClase }
        });

        const existe = check.data && Object.keys(check.data).length > 0;

        console.log("📌 ¿Existe evaluación?:", existe);

        // 2️⃣ Escoger método según exista o no
        let response;
        if (existe) {
            // PUT → Actualización
            response = await axios.put(routeUpdateEvaluation, {
                id_evaluaciones: idClase,
                evaluacion_diagnostica: evaluacionDiagnostica,
                evaluacion_final: evaluacionFinal,
                satisfaccion: satisfaccion
            });
        } else {
            // POST → Creación
            response = await axios.post(routeCreateEvaluation, {
                id_evaluaciones: idClase,
                evaluacion_diagnostica: evaluacionDiagnostica,
                evaluacion_final: evaluacionFinal,
                satisfaccion: satisfaccion
            });
        }

        console.log("📌 Respuesta:", response.data);

        if (response.data.ok || response.data.mensaje) {
            alert(response.data.mensaje || "Operación realizada correctamente.");
        } else {
            setError(response.data.error || "Ocurrió un error en la operación.");
        }

    } catch (error) {
        console.error("❌ Error:", error);
        setError("No se pudo realizar la operación.");
    }
};


    
    return (
        <div className="full-page">
            <div className='container1'>
                <form onSubmit={handleSubmitEvaluation}>
                    <div className="title"><h1>Crear Evaluación</h1></div>

                    <div className='class-name'>
                        <label>Matricula de clase</label>
                        <input
                            type="text"
                            placeholder="Escribe para buscar..."
                            value={matriculaClase}
                            onChange={handleSelection}
                            list="clases-list"
                        />
                        <datalist id="clases-list">
                            {optionsMatricula.map((option, index) => (
                                <option key={index} value={option} />
                            ))}
                        </datalist>
                    </div>

                    <div className='class-description'>
                        <label>Evaluación Diagnóstica</label>
                        <div><input type="text" value={evaluacionDiagnostica} onChange={(e) => setEvaluacionDiagnostica(e.target.value)} /></div>
                    </div>

                    <div className='teacher-id'>
                        <label>Evaluación Final</label>
                        <div><input type="text" value={evaluacionFinal} onChange={(e) => setEvaluacionFinal(e.target.value)} /></div>
                    </div>

                    {/* ✅ Encuesta de Satisfacción con el mismo estilo que los otros campos */}
                    <div className='teacher-id'>
                        <label>Encuesta de Satisfacción</label>
                        <div><input type="text" value={satisfaccion} onChange={(e) => setSatisfaccion(e.target.value)} /></div>
                    </div>

 <div className='submit'>
    <button type="submit">Crear Evaluaciones</button>
    {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}
</div>

                </form>
                <div className='return-home'>
                    <span onClick={() => navigate("/admin-home")}>Regresar Home</span>
                </div>
            </div>
        </div>
    );
};
